import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";

export class GameAssets {

    public static BITMAP_FONT_OPENSANS_800: string = "NumbersOpenSans800";
    public static BITMAP_FONT_WIN_COUNT_UP: string = "NumbersWinCountUp";
    public static BITMAP_FONT_MULTI: string = "NumbersMulti";

    public static GAME_LOGO: string = "logo";
    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                assets: [
                    new BitmapFontAsset(GameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(GameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset(GameAssets.BITMAP_FONT_MULTI, "fonts/bitmapfonts/NumbersMulti.fnt")
                ],
                autoLoad: [AssetQualityLevel.HIGH]
            },
            {
                name: "backgrounds",
                assets: [
                    new TextureAsset("backgroundsJpeg0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("backgroundsJpeg1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                ]
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("allPSymbols", "spine/P.json"),
                    new SpineAsset("XS", "spine/XS.json"),
                    new SpineAsset("W", "spine/W.json"),
                    new SpineAsset("S", "spine/S.json"),
                    new SpineAsset("XB", "spine/XB.json"),
                    new SpineAsset("sMeterLandscape", "spine/S_meter_landscape.json"),
                    new SpineAsset("sMeterPortrait", "spine/S_meter_portrait.json"),
                    new SpineAsset("XN", "spine/xn.json"),
                    new SpineAsset("C1", "spine/c1.json"),
                    new SpineAsset("C2", "spine/c2.json"),
                    new SpineAsset("C3", "spine/c3.json"),
                    new SpineAsset("C4", "spine/c4.json"),
                    new SpineAsset("GE", "spine/GE.json"),
                    new SpineAsset("airstrike", "spine/airstrike.json"),
                    new SpineAsset("fsIntro", "spine/FS_intro.json"),
                    new SpineAsset("sfsIntro", "spine/SFS_intro.json"),
                    new SpineAsset("mayhemIntro", "spine/Mayhem_intro.json"),
                    new SpineAsset("mayhemRetriggerIntro", "spine/Mayhem_retrigger.json"),
                    new SpineAsset("mX", "spine/MX.json"),
                    new SpineAsset("hps", "spine/hps.json"),
                    new SpineAsset("multiplier", "spine/multipliers.json"),
                    new SpineAsset("multiBox", "spine/multi_box.json"),
                    new SpineAsset("wallTop", "spine/wall_top.json"),
                    new SpineAsset("wallRight", "spine/wall_right.json"),
                    new SpineAsset("wallBottom", "spine/wall_bottom.json"),
                    new SpineAsset("wallLeft", "spine/wall_left.json"),
                    new SpineAsset("wallTopLeft", "spine/wall_corner_TL.json"),
                    new SpineAsset("wallTopRight", "spine/wall_corner_TR.json"),
                    new SpineAsset("wallBottomRight", "spine/wall_corner_BR.json"),
                    new SpineAsset("wallBottomLeft", "spine/wall_corner_BL.json"),
                    new SpineAsset("GR", "spine/GR.json"),
                    new SpineAsset("BU", "spine/BU.json"),
                    new SpineAsset("BZ", "spine/BZ.json"),
                    new SpineAsset("AS", "spine/AS.json"),
                    new SpineAsset("gEEffect", "spine/GE_effect.json"),
                    new SpineAsset("bigWins", "spine/bigwins.json"),
                    new SpineAsset("monsterWins", "spine/winlabel.json"),
                    new SpineAsset("baseBg", "spine/base_background.json"),
                    new SpineAsset("fsBg", "spine/fs_background.json"),
                    new SpineAsset("mayhemBg", "spine/sfs_background.json"),
                    new SpineAsset("hat", "spine/hat.json"),
                    new SpineAsset("hatHurt", "spine/hat_hurt.json"),
                    new SpineAsset("healthUp", "spine/health_up.json"),
                ]
            },
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json")
                ]
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                    new TextureAsset("mainJpeg10", "sheets/mainJpeg/mainJpeg10.json"),
                    new TextureAsset("mainJpeg11", "sheets/mainJpeg/mainJpeg11.json")
                ],
                animations: {
                    "1Break": "P_sym_break/P1_break/P1_break_",
                    "2Break": "P_sym_break/P2_break/P2_break_",
                    "3Break": "P_sym_break/P3_break/P3_break_",
                    "4Break": "P_sym_break/P4_break/P4_break_",
                    "multiplierStars": "Multipliers/stars/stars_"
                }
            },
            {
                name: "symbols",
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ],
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH]
            },
            {
                name: "noTinyPng",
                autoLoad: [ AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("noTinyPng0", "sheets/noTinyPng/noTinyPng0.json")
                ]
            }
        ]
    };
    public static highlightPaySymbolMap: Map<string, string> = new Map([['P1', 'HL_C1'], ['P2', 'HL_C2'], ['P3', 'HL_C3'], ['P4', 'HL_C4']]);

    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        if (stateName === null || stateName === "") {
            return symbolName + "/" + symbolName;
        }
        return symbolName + "/" + symbolName + "" + stateName;
    }
}